import styled from "styled-components";
import { COLORS } from "../../../constants";
import { useNavigate } from "react-router-dom";
import { Image } from "../../_ui";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  padding-bottom: 60px;
`;

const CardContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: 92px;
  max-width: 900px;
  align-items: flex-start;
  background-color: ${COLORS.PRIMARY};
  border-radius: 20px 20px 20px 20px;
  cursor: pointer;
  &:hover {
    box-shadow: rgba(0, 0, 0, 0.5) 0px 0px 6px;
  }
`;

const ImageContainer = styled.div`
  height: "92px" ;
  width: "92px";
  overflow: hidden;
  object-fit: cover;
`;

const Title = styled.h3`
  color: ${COLORS.WHITE};
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: auto;
`;

const Card = ({ text, image, route, imageContain }: { text: string, image?: string, route: (() => string), imageContain?: boolean }) => {
  const navigate = useNavigate();

  let linkTo = () => navigate(route());

  if (route().startsWith('http')) {
    linkTo = () => window.open(route(), '_blank')?.focus();
  }

  return (
    <CardContainer className="fadeIn" onClick={linkTo}>
      <ImageContainer>
        {image && (
          imageContain ? (
            <div
              style={{
                height: '92px',
                aspectRatio: '296 / 171',
                background: '#FFFFFF',
                borderRadius: '20px 0px 0px 20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                overflow: 'hidden',
              }}
            >
              <img
                src={image}
                alt=""
                style={{ maxWidth: '75%', maxHeight: '75%', objectFit: 'contain' }}
              />
            </div>
          ) : (
            <Image src={image} height="92px" width="auto" style={{ borderRadius: "20px 0px 0px 20px" }} />
          )
        )}
      </ImageContainer>
      <Title>{text}</Title>
    </CardContainer>
  )
}

export default Card